import React from 'react';
import { motion } from 'framer-motion';
interface MobileBookBarProps {
  onBookClick: () => void;
}
export function MobileBookBar({
  onBookClick
}: MobileBookBarProps) {
  return <motion.div initial={{
    y: 100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 1
  }} className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-matte-black/95 backdrop-blur-lg border-t border-off-white/10 p-4" data-id="element-165">
      <motion.button onClick={onBookClick} whileTap={{
      scale: 0.95
    }} className="w-full py-4 rounded-full bg-soft-gold text-matte-black font-inter font-bold text-lg shadow-[0_0_20px_rgba(212,175,55,0.4)]" data-id="element-166">
        Book Appointment
      </motion.button>
    </motion.div>;
}